import { Component, ElementRef, Renderer2 } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { LoaderService } from './services/loader.service';
import { WalletService } from './services/wallet.service';

declare var confetti: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'tezzardz-web';

  transactionLoading$: Observable<boolean>;
  loadingText$: Observable<string>;
  showCongratulation$: Observable<number>;

  canvas: any;

  constructor(
    private loaderService: LoaderService,
    private renderer2: Renderer2,
    private elementRef: ElementRef
  ) {
    this.canvas = this.renderer2.createElement('canvas');
    this.transactionLoading$ = this.loaderService.isLoading$;
    this.loadingText$ = this.loaderService.loadingText$;
    this.showCongratulation$ = this.loaderService.showCongratulation$.pipe(
      tap((amount) => {
        if (amount) {
          const colors = ['#a5e9c3', '#ead3ff', '#ecb494'];
          // const end = Date.now() + 15 * 1000;

          this.renderer2.appendChild(
            this.elementRef.nativeElement,
            this.canvas
          );

          const myConfetti = confetti.create(this.canvas, {
            resize: true,
          });

          myConfetti({
            particleCount: 120,
            spread: 120,
            origin: { y: 0.6 },
            colors: colors,
          });
        }
      })
    );
  }

  dismiss() {
    this.loaderService.setLoading(false);
    this.loaderService.showCongratulation$.next(0);
  }
}
